import { render } from "./Settings.vue?vue&type=template&id=33196054&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=33196054&scoped=true&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33196054"]])

export default __exports__